import type { UserRetailAccount } from '../types';

interface Props {
  account: Pick<UserRetailAccount, 'isPaper' | 'active'>;
  /** Show active/inactive pulse dot (dashboard style). */
  showActiveDot?: boolean;
}

const BADGE_BASE =
  'inline-flex shrink-0 items-center gap-[5px] rounded-full border border-transparent px-2 py-0.5 text-[0.65rem] font-semibold uppercase leading-[1.2] tracking-[0.05em]';

const ComparisonAccountModeBadge = ({
  account,
  showActiveDot = false,
}: Props) => {
  const isPaper = account.isPaper;
  const label = isPaper ? 'Paper' : 'Live';

  const toneClass = isPaper
    ? 'bg-primary/12 text-primary border-primary/35'
    : 'bg-secondary/12 text-secondary border-secondary/35';

  return (
    <span
      className={`${BADGE_BASE} ${toneClass}`}
      title={account.active ? 'Account is active' : 'Account is inactive'}
    >
      {showActiveDot && (
        <span
          className={`inline-block h-1.5 w-1.5 shrink-0 rounded-full ${
            account.active
              ? 'bg-positive'
              : 'bg-white/[0.28]'
          }`}
          aria-hidden
        />
      )}
      {label}
    </span>
  );
};

export default ComparisonAccountModeBadge;
